import React, { useState,useEffect} from 'react';
import * as S from './HobListingMmtStyles';
import LoadingScreenMmt from '../LoadingScreenMmt/LoadingScreenMmt'
import PopUpMmt from '../PopUpMmt/PopupMmt'
import { useHistory } from 'react-router-dom'
import { API_STATUS, CONSTANTS, DASHED_LINE_URL, DEFAULT_CONTACT_DETAILS, GOLD_STAR_URL, HOB_BOTTOMSHEET_CANCEL, HOB_BOTTOMSHEET_COMM_TXT, HOB_BOTTOMSHEET_CONFIRM_BOOKING, HOB_BOTTOMSHEET_EMAIL, HOB_BOTTOMSHEET_FULL_NAME, HOB_BOTTOMSHEET_INFO, HOB_BOTTOMSHEET_MOB_NO, HOB_LEFT_ICON, HOB_MMT_LOGO_URL, MAKE_MY_TRIP, PLEASE_CONFIRM_TRAVELLER_DETLS, PLEASE_ENTER_FULL_NAME, PLEASE_ENTER_VALID_EMAIL, PLEASE_ENTER_VALID_MOBILE_NO, PROVISIONAL_HOB_REQUEST_TYPE, TRAVELLER_DETAILS, WHITE_STAR_URL, errActionCta, errIcon } from '../../../../../config/constants';
import { getCheckFareHOBMmt, getHoldResponseForHOBMmt, checkHobUserDetailsMmt } from '../../../redux/thunks';
import { useDispatch, useSelector } from 'react-redux';
import { hobAirportCityCodeSelector, hobDestinationLocationSelector, hobFlightIdSelector, hobIsDepartureSelector, hobPickupTimeSelector, hobSourceLocationSelector, hobSourceMessageSelector, hobSourceSelector, hobTerminalSelector, useSourceLocationSelector } from '../../../redux/selector';
import { UPDATE_HOB_LISTING_RESPONSE } from '../../../redux/action-types';
import { ANOTHER_BOOKING_CLOSE_CLICKED_MMT, ANOTHER_BOOKING_CONFIRM_CLICKED_MMT, ANOTHER_BOOKING_POPUP_SHOWN_MMT, CONFIRM_BOOKING_CLICKED_MMT, HOB_CAB_AVAILABLE_MMT, HOB_CAB_NOT_AVAILABLE_MMT, HOB_HOLD_ERROR, HOB_USER_ERROR, LISTING_FILTER_APPLY_MMT, LISTING_HEADER_BACK_CLICKED, LOGIN_SHOWN_MMT, LOGIN_SUCCESS_MMT, OS_SEARCH_MMT, SUPPLIER_NAME_MMT, SUPPLIER_SHOWN_MMT, USER_DETAILS_CLOSED_MMT, USER_DETAILS_SHOWN_MMT } from '../../../../../utils/util-constants';
import { PROVISIONAL_HOB_OVERLAY_PAGE_LISTING, trackEvent, trackPageView } from '../../../../../config/omniMmt';
import  FilterBar  from '../FilterBar/FilterBar';
import HobBottomSheet from '../../HobBottomSheet/HobBottomSheet';
import ErrorScreen from '../../../HobLanding/mmt-components/ErrorMmtScreen/ErrorMmtScreen';
import { formValidator, setCookie } from '../../../../../config/utils';
import AnotherBookingPopup from '../AnotherBookingPopupMmt/AnotherBookingPopupMmt';
import CustomRadioButton from '../../../../../../stories/core-components/CustomRadioButtonUI/CustomRadioButtonUI';
import { setter, getter } from '@stencil/client-side-storage';

const HobListingMmt = (props) => {

  const history = useHistory()
  const dispatch = useDispatch()

  const [selectedCardKey, setSelectedKey] = useState(null);
  const [selectedCardData, setSelectedCardData] = useState(null);
  const [holdStatus, setHoldStatus] = useState(API_STATUS.INITIAL)
  const [holdApiResponse, setHoldApiResponse] = useState({});
  const [checkFareApiStatus, setCheckFareApiStatus] = useState(API_STATUS.INITIAL);
  const [checkHobUserStatus, setCheckHobUserStatus] = useState(API_STATUS.INITIAL);
  const [apiResponse, setApiResponse] = useState({});
  const [holdPopUpMessage, setHoldPopUpMessage] = useState('');
  const [checkFarePopUpMessage, setCheckFarePopUpMessage] = useState('');
  const [data,setData]= useState({})
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [preferedCabList, setPreferedCabList] = useState([]);
  const [othersCabList, setOthersCabList] = useState([]);
  const [hobUserDetailsData, setHobUserDetailsData] = useState(null)
  const [errScreenData, setErrScreenData] = useState(null);
  const [showWidget, setShowWidget] = useState(false);
  const [isPopupShown, setIsPopupShown] = useState(false);
  const [welcomeText, setWelcomeText] = useState('');
  const [showInputError, setShowInputError] = useState({
    name: false,
    email: false,
    mobile: false
  });
  const [formDetails, setFormDetails] = useState({
    gender: "M",
    first_name: null,
    last_name: null,
    email: null,
    mobileNumber: null
  })

  const flightId = useSelector(hobFlightIdSelector)
  const source = useSelector(hobSourceSelector)
  const isDeparture = useSelector(hobIsDepartureSelector)
  const pickupTime = useSelector(hobPickupTimeSelector)
  const destinationLocation = useSelector(hobDestinationLocationSelector)
  const sourceMessage = useSelector(hobSourceMessageSelector)
  const terminal = useSelector(hobTerminalSelector)
  const airportCityCode = useSelector(hobAirportCityCodeSelector)
  const sourceLocation = useSelector(hobSourceLocationSelector)
  const useSourceLocation = useSelector(useSourceLocationSelector)

  const returnVendorsArray = (data = null)=>{
    const suppliersArray = [];
    data?.isMMTPreferred?.cards?.forEach((card) => {
      suppliersArray.push(card?.brand?.title);
    });
    data?.others?.cards?.forEach((card) => {
      suppliersArray.push(card?.brand?.title);
    });
    return suppliersArray;
  }

  const handleCheckFareResponse = async (checkFareResponse) => {
    setApiResponse(checkFareResponse);
    dispatch({
      type: UPDATE_HOB_LISTING_RESPONSE,
      data: checkFareResponse?.response
    })
    if (Boolean(checkFareResponse?.errors?.error_list?.length)) {
      const eventDetails = {
        eVar22: `${checkFareResponse?.errors?.error_list[0]?.code ?? ''}_${airportCityCode}_${destinationLocation?.address}`
      }
      trackPageView(PROVISIONAL_HOB_OVERLAY_PAGE_LISTING, eventDetails)
      
      setCheckFareApiStatus(API_STATUS.INITIAL);
      setCheckFarePopUpMessage(checkFareResponse?.errors?.error_list[0]?.message || checkFareResponse?.errors?.error_list[0]?.code);
      return;
    }

    const suppliersString = returnVendorsArray(checkFareResponse?.response?.funnel_cab_card).join(' | ');
    const eventDetails = {
      prop54: 'Listing Load Success',
      eVar46: checkFareResponse?.response?.avg_price,
      eVar9: checkFareResponse?.response?.trip_type,
      eVar71: source
    }
    trackPageView(PROVISIONAL_HOB_OVERLAY_PAGE_LISTING, eventDetails)
    if (checkFareResponse?.response?.funnel_cab_card) {
      trackEvent(PROVISIONAL_HOB_OVERLAY_PAGE_LISTING, HOB_CAB_AVAILABLE_MMT)
    } else {
      trackEvent(PROVISIONAL_HOB_OVERLAY_PAGE_LISTING, HOB_CAB_NOT_AVAILABLE_MMT)
    }
    if (checkFareResponse?.response?.filters?.length) {
      trackEvent(PROVISIONAL_HOB_OVERLAY_PAGE_LISTING,`Hob_Listing_${checkFareResponse?.response?.filters?.join('_')}_Shown`)
    }
    trackEvent(PROVISIONAL_HOB_OVERLAY_PAGE_LISTING, `${SUPPLIER_SHOWN_MMT}_${suppliersString}`)
    if(checkFareResponse?.response?.trip_type === CONSTANTS.OW){
      trackEvent(PROVISIONAL_HOB_OVERLAY_PAGE_LISTING, OS_SEARCH_MMT)
    }

    if (!flightId) {
      setHobUserDetailsData(null)

      const isLoginShown = await getter("isLoginShown")
  
      if (isLoginShown) {
        trackEvent(PROVISIONAL_HOB_OVERLAY_PAGE_LISTING, LOGIN_SUCCESS_MMT)
        checkHobUser()
      }
    }

    setCheckFareApiStatus(API_STATUS.SUCCESS);
  };

  const formatTextWithBold = (text)=> {

    const boldRegex = /\*([^*]+)\*/g;
    return text.split(boldRegex).map((part, index) => {
      if (index % 2 === 0) {
        return part;
      } else {
        return <strong key={index}>{part}</strong>;
      }
    });
  }

  const getCheckFareRequest = () => {
    let reqParams = {}
    if (flightId && !sourceLocation) {
      reqParams = {
        type: PROVISIONAL_HOB_REQUEST_TYPE,
        tracking_params: null,
        device_info: null,
        flight_id: flightId,
        destination_location: destinationLocation,
        source_param: source,
        is_departure: isDeparture,
        pickup_time: pickupTime != null ? parseFloat(pickupTime) : null,
        source_message :sourceMessage
      }
    } else {
      reqParams = {
        type: PROVISIONAL_HOB_REQUEST_TYPE,
        tracking_params: null,
        device_info: null,
        source_location: sourceLocation,
        destination_location: destinationLocation,
        source_param: source,
        is_departure: isDeparture,
        pickup_time: pickupTime != null ? parseFloat(pickupTime) : null,
        source_message :sourceMessage
      }

      if (flightId) reqParams['flight_id'] = flightId;
    }

    return reqParams
  };

  const fetchCheckFareResponse = async () => {
    const checkFareRequest = getCheckFareRequest();
    try {
      setCheckFareApiStatus(API_STATUS.LOADING);
      const checkFareResponse = await getCheckFareHOBMmt(checkFareRequest);
      handleCheckFareResponse(checkFareResponse);
    } catch (e) {
      setCheckFareApiStatus(API_STATUS.INITIAL);
      return;
    }
  }

  useEffect(() => {
    fetchCheckFareResponse();
  }, []);

  useEffect(() => {
    if (holdStatus === API_STATUS.SUCCESS && holdApiResponse?.status === CONSTANTS.SUCCESS && holdApiResponse?.response?.tyPageUrl && typeof window !== "undefined") {
      window.location.replace(holdApiResponse?.response?.tyPageUrl);
    };
  }, [holdStatus, holdApiResponse])

  useEffect(() => {
    if (apiResponse) {
      setData(apiResponse?.response);  
      setSelectedFilters(apiResponse?.response?.pre_selected_filter ? [apiResponse?.response?.pre_selected_filter] : []);
    }
  }, [apiResponse]);

  useEffect(() => {
    const newPreferedCabs = selectedFilters?.length> 0 ? data?.funnel_cab_card?.isMMTPreferred?.cards?.filter(card =>
      selectedFilters?.includes(card?.cab_offering?.cab_type)
    ) || [] : data?.funnel_cab_card?.isMMTPreferred?.cards

    const newOthersCabs = selectedFilters?.length>0 ? data?.funnel_cab_card?.others?.cards?.filter(card =>
      selectedFilters?.includes(card?.cab_offering?.cab_type)
    ) || [] : data?.funnel_cab_card?.others?.cards

    setPreferedCabList(newPreferedCabs);
    setOthersCabList(newOthersCabs);
  },[selectedFilters])

  useEffect(() => {
    if(preferedCabList?.length > 0){
      handleCardClick(preferedCabList[0],true)
    }
    else if(othersCabList?.length > 0){
      handleCardClick(othersCabList[0],true)
    }
  },[preferedCabList,othersCabList])

  const checkHobUser = async () => {
    if (hobUserDetailsData?.showLogin) {
      openLoginFlow()
      return
    }

    const req = {
      type: "userDetailsRequest",
      pickup_time: pickupTime != null ? parseFloat(pickupTime) : null
    }
    setCheckHobUserStatus(API_STATUS.LOADING)

    try {
      const checkHobUserResp = await checkHobUserDetailsMmt(req)

      if (Boolean(checkHobUserResp?.errors?.error_list?.length)) {
        const eventDetails = {
          eVar22: `${checkHobUserResp.errors?.error_list[0].code}_${data?.source_location?.address || ''}_${data?.destination_location?.address || ''}`
        }
        trackEvent(PROVISIONAL_HOB_OVERLAY_PAGE_LISTING, HOB_USER_ERROR, eventDetails)
        setErrScreenData(checkHobUserResp?.errors?.error_list[0]);
        setCheckHobUserStatus(API_STATUS.INITIAL)
      } else {
        setHobUserDetailsData(checkHobUserResp?.response)
        if (checkHobUserResp?.response?.userDetails) {
          const formDetailsVal = {
            first_name: checkHobUserResp?.response?.userDetails?.lastName?.length ? checkHobUserResp?.response?.userDetails?.firstName + ' ' + checkHobUserResp?.response?.userDetails?.lastName : checkHobUserResp?.response?.userDetails?.firstName,
            last_name: '',
            email: checkHobUserResp?.response?.userDetails?.email,
            mobileNumber: checkHobUserResp?.response?.userDetails?.mobileNumber,
            gender: checkHobUserResp?.response?.userDetails?.gender?.length ? checkHobUserResp?.response?.userDetails?.gender : "M"
          }
          setFormDetails(formDetailsVal)
        }

        if (checkHobUserResp?.response?.bookingPopUp) {
          trackEvent(PROVISIONAL_HOB_OVERLAY_PAGE_LISTING, ANOTHER_BOOKING_POPUP_SHOWN_MMT)
          const isLoginShown = await getter("isLoginShown")
          if (isLoginShown) {
            setWelcomeText(`Welcome Back ${checkHobUserResp?.response?.userDetails?.firstName} !`)
            setter("isLoginShown", false)
          }
          setCheckHobUserStatus(API_STATUS.SUCCESS)
          return
        }

        if (checkHobUserResp?.response?.showLogin) {
          setCheckHobUserStatus(API_STATUS.SUCCESS)
          setter("isLoginShown", true)
          openLoginFlow()
        } else if (checkHobUserResp?.response?.showWidget) {
          trackEvent(PROVISIONAL_HOB_OVERLAY_PAGE_LISTING, USER_DETAILS_SHOWN_MMT)
          setCheckHobUserStatus(API_STATUS.SUCCESS)
          setShowWidget(true)
          const isLoginShown = await getter("isLoginShown")
          if (isLoginShown) {
            setWelcomeText(`Welcome Back ${checkHobUserResp?.response?.userDetails?.firstName} !`)
            setter("isLoginShown", false)
          }
        }
      }
    } catch (e) {
      setCheckHobUserStatus(API_STATUS.INITIAL)
      return;
    }
  }

  const checkFormError = (key : string) : boolean => {
    const isValid = formDetails[key]?.length ? formValidator({type: key === "mobileNumber" ? "phone_number" : key, value: formDetails[key]}) : false;
    return isValid
  }

  const isFormDetailsError = () : boolean => {
    const isNameValid = checkFormError("first_name")
    const isEmailValid = checkFormError("email")
    const isMobileValid = checkFormError("mobileNumber")

    setShowInputError({
      name: !isNameValid,
      email: !isEmailValid,
      mobile: !isMobileValid
    })

    return !isNameValid || !isEmailValid || !isMobileValid
  }

  /**
 * Handles the process of booking a cab, performs necessary checks, calls hold api,and updates the booking status accordingly.
 * @returns {void}
 */
  const handleBookClick = async () => {
    if (!flightId && !hobUserDetailsData?.showWidget) {
      checkHobUser()
    } else {
      if (!flightId && isFormDetailsError()) {
        setShowWidget(true)
        return
      }
      trackEvent(PROVISIONAL_HOB_OVERLAY_PAGE_LISTING, CONFIRM_BOOKING_CLICKED_MMT)
      trackEvent(PROVISIONAL_HOB_OVERLAY_PAGE_LISTING, `${SUPPLIER_NAME_MMT}_${selectedCardData?.brand?.title}_Selected`)

      let holdRequest = {}

      if (!flightId) {
        holdRequest = {
          type: CONSTANTS.holdBookingRequest,
          destination_location: data?.destination_location,
          version: CONSTANTS.V3,
          source_location: data?.source_location,
          advance_type: CONSTANTS.ZERO_PAYMENT,
          funnel_source: CONSTANTS.hob_funnel,
          search_id: selectedCardData?.search_id,
          cab_key: selectedCardData?.cab_key,
          category_id: selectedCardData?.category_id,
          hob_search_id: data?.hob_search_id,
          userDetails: hobUserDetailsData?.userDetails,
          passenger_details: formDetails,
          flow_name: source
        };
      } else {
        holdRequest = {
          type: CONSTANTS.holdBookingRequest,
          flight_booking_id: flightId,
          destination_location: data?.destination_location,
          version: CONSTANTS.V3,
          source_location: data?.source_location,
          advance_type: CONSTANTS.ZERO_PAYMENT,
          funnel_source: CONSTANTS.hob,
          search_id: selectedCardData?.search_id,
          cab_key: selectedCardData?.cab_key,
          category_id: selectedCardData?.category_id,
          provBookingId: data?.prov_booking_id,
          flow_name: source
        };
      }
  
      try {
        setHoldStatus(API_STATUS.LOADING)
        const holdResponse = await getHoldResponseForHOBMmt(holdRequest);
        
        setHoldApiResponse(holdResponse)
        if (Boolean(holdResponse?.errors?.error_list?.length)) {
          const eventDetails = {
            eVar22: `${holdResponse.errors?.error_list[0].code}_${data?.source_location?.address || ''}_${data?.destination_location?.address || ''}`
          }
          trackEvent(PROVISIONAL_HOB_OVERLAY_PAGE_LISTING, HOB_HOLD_ERROR, eventDetails)

          setHoldStatus(API_STATUS.INITIAL);
          setHoldPopUpMessage(holdResponse?.errors?.error_list[0]?.message || holdResponse?.errors?.error_list[0]?.code)
          return;
        }
      }
      catch (e) {
        setHoldStatus(API_STATUS.INITIAL)
        return;
      }
      setHoldStatus(API_STATUS.SUCCESS)
    }
  }

  const openLoginFlow = () => {
    trackEvent(PROVISIONAL_HOB_OVERLAY_PAGE_LISTING, LOGIN_SHOWN_MMT)
    const loginActionDetails = {
      actionURL: `${window.location.href}`,
      verifyOTP: false,
      isOTPVerified: false,
      openVerifiedPage: false,
      optPageOpened: false
    };
    const expires = new Date(Date.now() + 1200000);
    setCookie('loginActionDetails', JSON.stringify(loginActionDetails), {
      expires,
      path: '/',
      domain: '.makemytrip.com'
    });
    window.location.href = 'https://www.makemytrip.com/pwa/hlp/v3/login/?open=browser';
  }

  const formattedDetail = data?.search_detail?.map((item, index, array) => {
    return (
      <span key={index}>
        {formatTextWithBold(item)}
        {index !== array.length - 1 && <span style={{ margin: '0 4px' }}>|</span>}
      </span>
    );
  });

  const handleBack = (isHeaderBackClicked = false) => {
    if (isHeaderBackClicked) {
      trackEvent(PROVISIONAL_HOB_OVERLAY_PAGE_LISTING, LISTING_HEADER_BACK_CLICKED)
    }
    history.goBack();
  }

  const handleCardClick = (card,isPreSelectCall = false) => {
    setSelectedKey(card?.cab_key + card?.search_id);
    setSelectedCardData(card)
  };

  const handleFilterSelect = (filter : string) => {
    trackEvent(PROVISIONAL_HOB_OVERLAY_PAGE_LISTING, `${LISTING_FILTER_APPLY_MMT}_${filter}`);
    setSelectedFilters([filter]);
  };

  const onUserDetailsUpdate = (key : string, val : string) => {
    const newFormDetails = {...formDetails};
    setFormDetails({...newFormDetails, [key]: val})
  }

  const onClose = () => {
    trackEvent(PROVISIONAL_HOB_OVERLAY_PAGE_LISTING, USER_DETAILS_CLOSED_MMT)
    setShowWidget(false)
  }

  const onPositiveAction = () => {
    trackEvent(PROVISIONAL_HOB_OVERLAY_PAGE_LISTING, ANOTHER_BOOKING_CONFIRM_CLICKED_MMT)
    setIsPopupShown(true)
    setShowWidget(true)
  }

  const onNegativeAction = () => {
    trackEvent(PROVISIONAL_HOB_OVERLAY_PAGE_LISTING, ANOTHER_BOOKING_CLOSE_CLICKED_MMT)
    handleBack(false);
  }

  if (errScreenData) {
    return (
      <ErrorScreen
        title={errScreenData?.title}
        message={errScreenData?.message || errScreenData?.code}
        icon={errIcon}
        cta={errActionCta}
        isListing={true}
      />
    );
  }

  if (hobUserDetailsData?.bookingPopUp && Object.keys(hobUserDetailsData?.bookingPopUp)?.length && !isPopupShown) {
    return (
      <AnotherBookingPopup 
        shouldShow={true} 
        onPositiveAction={onPositiveAction}
        onNegativeAction={onNegativeAction}
        popupDetails={hobUserDetailsData?.bookingPopUp}
      />
    );
  }

  if (Boolean(checkFarePopUpMessage)) {
    return (
      <PopUpMmt
        onCrossClick={() => {
          setCheckFarePopUpMessage('');
          handleBack(false);
        }}
        shouldShow={Boolean(checkFarePopUpMessage)}
        popUpMessage={checkFarePopUpMessage}
      />
    );
  }

  if (Boolean(holdPopUpMessage)) {
    return (
      <PopUpMmt
        onCrossClick={() => {
          setHoldPopUpMessage('');
          history.go(0)
        }}
        shouldShow={Boolean(holdPopUpMessage)}
        popUpMessage={holdPopUpMessage}
      />
    );
  }

  if (checkFareApiStatus === API_STATUS.LOADING)
    return (<LoadingScreenMmt />)

  if(checkFareApiStatus === API_STATUS.SUCCESS && apiResponse?.status === CONSTANTS.SUCCESS){
  return (
    <S.BrandListingScreen>
      <div className="brand-listing-header">
        <div className='header-container'>
          <img className="brand-mmt-logo" src={HOB_MMT_LOGO_URL} />
          <span className="brand-mmt-header-title">{MAKE_MY_TRIP}</span>
        </div>
        <div className="trip-destination-view">
          <img src={HOB_LEFT_ICON} className="brand-back-btn" onClick={() => handleBack(true)}></img>
          <S.SingleLineEllipsis className="trip-dest-text">{`${(terminal && !useSourceLocation ? terminal : data?.source_location?.address)|| ''} to ${(data?.destination_location?.address)|| ''}`}</S.SingleLineEllipsis>
        </div>
      </div>
      <div className="brand-listing-container">
        <div className="brand-filter-sec">
          <p>
            <span className="filterTexts">{formattedDetail}</span>
          </p>
        </div>
        {data?.filters && 
          <FilterBar filters={data?.filters} onFilterSelect={handleFilterSelect} selectedFilters={selectedFilters}/>
        }
        <div className="listing-section">
          <div className="brand-cab-card-container">
            {data?.funnel_cab_card?.isMMTPreferred && preferedCabList?.length > 0 ? (
              <div>
                <div className="recommended-section">
                  <span className="reLabel">{data?.funnel_cab_card?.isMMTPreferred?.text}</span>
                  <span className="circleSeperate"></span>
                  <div className="preferredTxt">{data?.funnel_cab_card?.isMMTPreferred?.sub_text}</div>
                </div>
                <div>

                  {preferedCabList?.map((card, i) => (
                    <div key={card?.cab_key + card?.search_id}
                      className={`brand-cab-card ${selectedCardKey === card?.cab_key + card?.search_id ? 'selected' : ''}`}
                      onClick={() => handleCardClick(card,false)}>
                      <div className="brand-cab-details">
                        <div className="img-section">
                          <div className="img-brandLogo">
                            <S.BrandImgSec src={card?.brand?.icon} />
                          </div>
                          <img className="brand-cab-img" src={card?.cab_offering?.cab_image} />
                        </div>
                        <div className="brand-cab-info">
                          <S.BrandLabelContainer>
                            <div className="brand-label">
                              <div>
                                <p className="brand-name-cab">{card?.brand?.title}</p>
                                {card?.brand?.rating &&
                                <div className="cab-rating-box">
                                  <S.StarImgIc src={WHITE_STAR_URL} />
                                  <span>{card?.brand?.rating}</span>
                                </div>
                                }
                              </div>
                              <p className="brand-car-name">{card?.cab_offering?.cab_type}</p>

                            </div>
                            <div>
                              <S.TimeLeftText>{card?.waiting_time}</S.TimeLeftText>
                            </div>
                          </S.BrandLabelContainer>
                          <S.BrandFareInfo>
                            <p className="total-amt-txt">{`\u20B9${card?.cab_offering?.current_price?.toLocaleString("en-US")}`}</p>
                            <p className="tax-msg-txt">{card?.cab_offering?.cab_type_label}</p>
                          </S.BrandFareInfo>
                        </div>
                      </div>
                      {card?.persuasions &&
                        <>
                          <S.LineImg src={DASHED_LINE_URL} />
                          <div className="brand-features">
                            {card?.persuasions?.map((feature, i) => {
                              return (
                                <div
                                  key={'brand-features' + i}
                                  className="brand-feat-item">
                                  {i === 0 ? (
                                    <div style={{background: card?.persuasion_color}} className="featureImgCont">
                                      <img src={GOLD_STAR_URL} className="golIcImg"></img>
                                    </div>
                                  ) : (
                                    <div className="dotSeperate-feature" style={{ backgroundColor: card?.persuasion_color }}
                                    />
                                  )}
                                  <span
                                    style={{ color: card?.persuasion_color }}
                                    className="brand-feature-text">
                                    {feature}
                                  </span>
                                </div>
                              );
                            })}
                          </div>
                        </>
                      }
                    </div>
                  ))}
                </div>
                {othersCabList?.length > 0 && (
                <S.OtherOptionText>{data?.funnel_cab_card?.others?.text}</S.OtherOptionText>
                )}
                {othersCabList?.map((card, i) => (
                  <div key={card?.cab_key + card?.search_id}
                  className={`brand-cab-card ${selectedCardKey === card?.cab_key + card?.search_id ? 'selected' : ''}`}
                    onClick={() => handleCardClick(card,false)}>
                    <div className="brand-cab-details">
                      <div className="img-section">
                        <div className="img-brandLogo">
                          <S.BrandImgSec src={card?.brand?.icon} />
                        </div>
                        <img className="brand-cab-img" src={card?.cab_offering?.cab_image} />
                      </div>
                      <div className="brand-cab-info">
                        <S.BrandLabelContainer>
                          <div className="brand-label">
                            <div>
                              <p className="brand-name-cab">{card?.brand?.title}</p>
                              {card?.brand?.rating &&
                              <div className="cab-rating-box">
                                <S.StarImgIc src={WHITE_STAR_URL} />
                                <span>{card?.brand?.rating}</span>
                              </div>
                              }
                            </div>
                            <p className="brand-car-name">{card?.cab_offering?.cab_type}</p>
                          </div>
                          <div>
                            <S.TimeLeftText>{card?.waiting_time}</S.TimeLeftText>
                          </div>
                        </S.BrandLabelContainer>
                        <S.BrandFareInfo>
                          <p className="total-amt-txt">{`\u20B9${card?.cab_offering?.current_price?.toLocaleString("en-US")}`}</p>
                          <p className="tax-msg-txt">{card?.cab_offering?.cab_type_label}</p>
                        </S.BrandFareInfo>
                      </div>
                    </div>
                    {card?.persuasions &&
                      <>
                        <S.LineImg src={DASHED_LINE_URL} />
                        <div className="brand-features">
                          {card?.persuasions?.map((feature, i) => {
                            return (
                              <div
                                key={'brand-features' + i}
                                className="brand-feat-item">
                                {i === 0 ? (
                                  <div style={{background: card?.persuasion_color}} className="featureImgCont">
                                    <img src={GOLD_STAR_URL} className="golIcImg"></img>
                                  </div>
                                ) : (
                                  <div className="dotSeperate-feature" style={{ backgroundColor: card?.persuasion_color }}
                                  />
                                )}
                                <span
                                  style={{ color: card?.persuasion_color }}
                                  className="brand-feature-text">
                                  {feature}
                                </span>
                              </div>
                            );
                          })}
                        </div>
                      </>
                    }
                  </div>
                ))}
              </div>
            ) : (
              <div>
                {othersCabList?.length > 0 && (
                <S.OtherRecommendedSection>{data?.funnel_cab_card?.others?.text}</S.OtherRecommendedSection>
                )}
                {othersCabList?.map((card, i) => (
                  <div key={card?.cab_key + card?.search_id}
                  className={`brand-cab-card ${selectedCardKey === card?.cab_key + card?.search_id ? 'selected' : ''}`}
                    onClick={() => handleCardClick(card,false)}>
                    <div className="brand-cab-details">
                      <div className="img-section">
                        <div className="img-brandLogo">
                          <S.BrandImgSec src={card?.brand?.icon} />
                        </div>
                        <img className="brand-cab-img" src={card?.cab_offering?.cab_image} />
                      </div>
                      <div className="brand-cab-info">
                        <S.BrandLabelContainer>
                          <div className="brand-label">
                            <div>
                              <p className="brand-name-cab">{card?.brand?.title}</p>
                              {card?.brand?.rating &&
                              <div className="cab-rating-box">
                                <S.StarImgIc src={WHITE_STAR_URL} />
                                <span>{card?.brand?.rating}</span>
                              </div>
                              }
                            </div>
                            <p className="brand-car-name">{card?.cab_offering?.cab_type}</p>
                          </div>
                          <div>
                            <S.TimeLeftText>{card?.waiting_time}</S.TimeLeftText>
                          </div>
                        </S.BrandLabelContainer>
                        <S.BrandFareInfo>
                          <p className="total-amt-txt">{`\u20B9${card?.cab_offering?.current_price?.toLocaleString("en-US")}`}</p>
                          <p className="tax-msg-txt">{card?.cab_offering?.cab_type_label}</p>
                        </S.BrandFareInfo>
                      </div>
                    </div>
                    {card?.persuasions &&
                      <>
                        <S.LineImg src={DASHED_LINE_URL} />
                        <div className="brand-features">
                          {card?.persuasions?.map((feature, i) => {
                            return (
                              <div
                                key={'brand-features' + i}
                                className="brand-feat-item">
                                {i === 0 ? (
                                  <div style={{background: card?.persuasion_color}} className="featureImgCont">
                                    <img src={GOLD_STAR_URL} className="golIcImg"></img>
                                  </div>
                                ) : (
                                  <div className="dotSeperate-feature" style={{ backgroundColor: card?.persuasion_color }}
                                  />
                                )}
                                <span
                                  style={{ color: card?.persuasion_color }}
                                  className="brand-feature-text">
                                  {feature}
                                </span>
                              </div>
                            );
                          })}
                        </div>
                      </>
                    }
                  </div>
                ))}

              </div>
            )}
          </div>
        </div>
      </div>
      <div className="footer-btn-sec">
        <S.SubText>{data?.payment?.subtext}</S.SubText>
        {holdStatus === API_STATUS.LOADING || checkHobUserStatus === API_STATUS.LOADING
          ?
          <S.CabPaymentCont>
            <S.BluePrimaryBtn>
              <S.BtnLoader />
            </S.BluePrimaryBtn>
          </S.CabPaymentCont>
          :
          <S.CabPaymentCont>
            <S.BluePrimaryBtn onClick={handleBookClick}>
              {data?.payment?.btn_payment_text}
            </S.BluePrimaryBtn>
          </S.CabPaymentCont>
        }
      </div>
      <HobBottomSheet isOpen={showWidget} onClose={() => onClose()} welcomeText={welcomeText} setInitialText={setWelcomeText} fontFamily={'Lato'}>
        <S.BottomSheetTopCont>
          <div className='title'>
            {TRAVELLER_DETAILS}
          </div>
          <img src={HOB_BOTTOMSHEET_CANCEL} onClick={() => onClose()}/>
        </S.BottomSheetTopCont>
        <S.BottomSheetSubtitle>
          {PLEASE_CONFIRM_TRAVELLER_DETLS}
        </S.BottomSheetSubtitle>
        <S.BottomSheetCommTxtCont>
          <img src={HOB_BOTTOMSHEET_INFO} />
          <div className='commTitle'>
            {HOB_BOTTOMSHEET_COMM_TXT}
          </div>
        </S.BottomSheetCommTxtCont>
        <S.GenderContainer>
          {DEFAULT_CONTACT_DETAILS?.map((gender, index) => {
            const isActive = !!(gender?.value === formDetails?.gender);
            return (
              <S.CustomRadioWrap
                id={gender?.value}
                onClick={() => onUserDetailsUpdate("gender", gender?.value)}
                key={`genderAttributes${index}`}
              >
                <CustomRadioButton isActive={isActive} backgroundColor={"#757575"} borderColor={"#000"} />
                <S.labelTxt> 
                  {gender?.title}
                </S.labelTxt>
              </S.CustomRadioWrap>
            );
          })}
        </S.GenderContainer>
        <S.InputCont>
          <div className='inoutContVal'>
            <div className='title'>
              {HOB_BOTTOMSHEET_FULL_NAME}
            </div>
            <input 
              type='text' 
              placeholder='Enter Full Name' 
              value={formDetails?.first_name}    
              autoFocus={!formDetails?.first_name}         
              onChange={(e) => onUserDetailsUpdate("first_name", e.target.value)}
              onBlur={() => {
                const isNameValid = checkFormError("first_name")
                setShowInputError({
                  ...showInputError,
                  name: !isNameValid
                })
              }}
            />
          </div>
          {showInputError?.name ? (
            <div className='errorText'>
              {PLEASE_ENTER_FULL_NAME}
            </div>
          ) : null}
        </S.InputCont>
        <S.InputCont width={"calc(100% - 40px)"}>
          <div className='inoutContVal'>
            <div className='title'>
              {HOB_BOTTOMSHEET_MOB_NO}
            </div>
            <div className="prefixInputCont">
              <div className='prefix'>
                + 91
              </div>
              <input 
                type='tel'
                placeholder='Enter Mobile No.' 
                value={formDetails?.mobileNumber}    
                autoFocus={!formDetails?.mobileNumber && formDetails?.first_name}         
                onChange={(e) => onUserDetailsUpdate("mobileNumber", e.target.value)}
                onBlur={() => {
                  const isMobileValid = checkFormError("mobileNumber")
                  setShowInputError({
                    ...showInputError,
                    mobile: !isMobileValid
                  })
                }}
              />
            </div>
          </div>
          {showInputError?.mobile ? (
            <div className='errorText'>
              {PLEASE_ENTER_VALID_MOBILE_NO}
            </div>
          ) : null}
        </S.InputCont>
        <S.InputCont>
          <div className='inoutContVal'>
            <div className='title'>
              {HOB_BOTTOMSHEET_EMAIL}
            </div>
            <input 
              type='email' 
              placeholder='Enter Email Id' 
              value={formDetails?.email}      
              autoFocus={formDetails?.mobileNumber && formDetails?.first_name && !formDetails?.email}         
              onChange={(e) => onUserDetailsUpdate("email", e.target.value)}
              onBlur={() => {
                const isEmailValid = checkFormError("email")
                setShowInputError({
                  ...showInputError,
                  email: !isEmailValid
                })
              }}
            />
          </div>
          {showInputError?.email ? (
            <div className='errorText'>
              {PLEASE_ENTER_VALID_EMAIL}
            </div>
          ) : null}
        </S.InputCont>

        <S.BottomSheetBtnCont>
          {holdStatus === API_STATUS.LOADING
            ?
            <S.CabPaymentCont>
              <S.BluePrimaryBtn>
                <S.BtnLoader />
              </S.BluePrimaryBtn>
            </S.CabPaymentCont>
            :
            <S.CabPaymentCont>
              <S.BluePrimaryBtn onClick={handleBookClick}>
                {HOB_BOTTOMSHEET_CONFIRM_BOOKING}
              </S.BluePrimaryBtn>
            </S.CabPaymentCont>
          }
        </S.BottomSheetBtnCont>
      </HobBottomSheet>
    </S.BrandListingScreen>
  );
  }
  return null;
};

export default HobListingMmt;